import { viVN_ProductInformation } from './information';
import { viVN_ProductManagement } from './management';

export const viVN_Product = {
  ...viVN_ProductInformation,
  ...viVN_ProductManagement
};
